<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <!-- Bouton de rafraîchissement -->
        <b-row class="justify-content-start">
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button class="btnFilter"
              @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
              {{ $t('filter.fltr') }}
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button
              class="btnFilter"
              :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
            {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
          <b-col cols="4" lg="3" xl="2" class="mb-5">
            <b-button variant="secondary"
              @click="actionAdd">
              <i class="fa-light fa-plus"></i>
              <span>{{$t('common.email.email_group_add')}}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="justify-content-start align-items-center" :class="{'filter-item-section':true, 'd-none': !displayFilter}">
          <b-col sm="3" class="form-group">
          <!-- Filtre GroupName -->
            <form-write-group-label-input v-model="GroupName"
              :inputLabel="$t('common.email.group_name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="justify-content-end" v-if="displayFilter">
          <!-- Boutons Effacer et Appliquer -->
          <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
            <b-button class="mr-3" size="sm"
              @click="clearFilterFields" :disabled="!GroupName">
              {{ $t('filter.clr_fltr_field') }}
            </b-button>
          </b-col>
          <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
            <b-button class="btn" size="sm"
              @click="onRefresh">
              {{ $t('common.srch') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-5">
          <div>
            <spinner v-if="activateSpinner"></spinner>
            <b-table v-else-if="listItemsEmailGroup.length > 0"
              :items="listItemsEmailGroup"
              :fields="fields"
              :sort-by.sync="sortBy"
              class="table-striped"
              fixed
              hover
              :selectable="listItemsEmailGroup.length > 0"
              :empty-text="$t('common.security.no_result')"
              @row-selected="onRowClicked"
              :key="refreshKey">
              <template #cell(GroupName)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(edit)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.item.IdEmailGroup)">
                  <i class="fa-regular fa-pencil"></i>
                </span>
              </template>
              <template #cell(delete)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.item.IdEmailGroup)">
                  <i class="fa-regular fa-trash"></i>
                </span>
              </template>
            </b-table>
            <div v-else class="d-flex justify-content-center">
              <span class="noResult">
                {{ $t('common.no_result') }}
              </span>
            </div>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"

export default {
  name: "EmailGroupPage",
  components: {
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinner: false,
      displayFilter: false,
      GroupName: '',
      listItemsEmailGroup: [],
      listTitle: "",
      refreshKey: false,
      sortBy: 'GroupName'
    }
  },
  created() {
    this.listTitle = this.$i18n.t("common.email.email_group_list")
    this.activateSpinner = true
    this.getEmailGroup()

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  computed: {
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []

      // fields.push({
      //   key: 'IdEmailGroup',
      //   label: this.$t('common.email.id'),
      //   thClass: 'text-center table-condensed-ipad',
      //   tdClass: 'p-0 text-center w-100 p-2 py-3',
      //   sortable: true
      // })

      fields.push({
        key: 'GroupName',
        label: this.$t('common.email.group_name'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      if (this.canEdit) {
        fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      if (this.canDelete) {
        fields.push({ key: 'delete', label: this.$t('rights.delete'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      return fields
    }
  },
  methods: {
    actionAdd () {
      loadPage(this, {url: '/email/emailGroup/add/-1' })
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.email.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { id: id }
              that.$engine.email.emailGroup.delete(params)
              .then(resp => {
                that.listItemsEmailGroup = that.listItemsEmailGroup.filter(item => item.IdEmailGroup !== id)
                that.$f7.modal({
                  title: that.$t('common.email.email_group_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, { url: '/email/emailGroup/-1' })
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.email.email_group_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      loadPage(this, { url: '/email/emailGroup/edit/' + id })
    },
    applyFilter () {
      this.activateSpinner = true
      this.getEmailGroup()
    },
    clearFilterFields () {
      this.GroupName = ''
      // this.applyFilter()
    },
    getEmailGroup () {
      let that = this
      let params = { GroupName: this.GroupName }
      this.$engine.email.emailGroup.fetch(params).then((resp) => {
        let emailGroupList = {}

        emailGroupList = resp.data.EmailGroup || []

        that.updateEmailGroup(emailGroupList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRefresh () {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getEmailGroup()
    },
    onRowClicked (item) {
      const emailGroupId = item[0].IdEmailGroup
      loadPage(this, { url: 'email/emailAddress/' + emailGroupId })
    },
    updateEmailGroup (emailGroupList) {
      this.listItemsEmailGroup = emailGroupList
    }
  }
}
</script>
